export const TEMPERATURE_MIN = 0;
export const TEMPERATURE_MAX = 30;
export const TEMPERATURE_STEP = 0.5;
